var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 10",
    width: 300,
    height: 100,
    role: "img",
    "aria-label": "Visa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 10)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1434cb",
    fillRule: "nonzero",
    d: "M15.475 6.71c-.017-1.344 1.198-2.094 2.113-2.54.94-.458 1.256-.751 1.253-1.16-.008-.627-.75-.903-1.446-.914-1.213-.019-1.918.328-2.479.59L14.48.64c.563-.26 1.604-.485 2.685-.495 2.535 0 4.194 1.251 4.203 3.192.01 2.463-3.407 2.6-3.383 3.7.008.334.326.69 1.024.78.346.047 1.3.082 2.38-.416l.425 1.978a6.471 6.471 0 01-2.26.415c-2.386 0-4.064-1.27-4.078-3.085m10.416 2.914a1.1 1.1 0 01-1.027-.684L21.242.29h2.533l.505 1.393h3.096L27.67.291h2.233l-1.949 9.333h-2.062m.355-2.521l.73-3.505h-2.002l1.272 3.505M12.403 9.624L10.406.291h2.414l1.996 9.333h-2.413m-3.572 0L6.318 3.272 5.3 8.673c-.12.603-.59.951-1.113.951H.079l-.057-.27c.843-.184 1.801-.48 2.382-.795.355-.193.457-.361.573-.82L4.903.291h2.552l3.912 9.333H8.83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.78a9dfb1ff1441c7d2be981b6a32355f.svg";
export { ForwardRef as ReactComponent };